import { Component, HostListener, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
  AbstractControl
} from '@angular/forms';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { LoginRequest } from '../../../services/authentication/models/login.request';
import { ValidateCustomEmail } from '../../shared/validators/type-validators';
import { HeaderTitleService } from '../../../modules/home/main/components/header-mobile/title-behavior-service/header-title.service';
import { EnvironmentService } from '../../../services/environment.service';
import { HyperFlowChatbotService } from 'src/app/services/hyperflow-chatbot/hyperflow-chatbot.service';
import { RedirectValidatorService } from 'src/app/services/shared/redirect-validator.service';
import { IRedirect } from 'src/app/shared/interfaces/redirect';
import { ToastrService } from 'ngx-toastr';
import { RegistrationErrorModel } from '../../../services/authentication/models/registration-error.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  hide = true;
  loginForm: UntypedFormGroup;
  incorrectData = false;
  urlNavigation: string = environment.urlLp;
  mobileScreen: boolean;
  screenWidth: number;
  hideMobileBackButton: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthenticationService,
    private router: Router,
    private headerTitleService: HeaderTitleService,
    private environmentService: EnvironmentService,
    private hyperFlowChatbotService: HyperFlowChatbotService,
    private redirectValidatorService: RedirectValidatorService,
    private toastrService: ToastrService
  ) {}

  redirect?: IRedirect;

  ngOnInit(): void {
    const redirect = this.redirectValidatorService.getValidRedirectParam();
    this.redirect = redirect;

    this.hyperFlowChatbotService.initWithScriptToken(
      environment.desloggedAreaChatbotToken
    );
    this.getScreenSize();
    this.createFormLogin();
    this.headerTitleService.setTitle('Login');
    this.hideMobileBackButton = this.environmentService.isReactNativeWebView;
  }

  createFormLogin(): void {
    const noWhiteSpaces = (control: AbstractControl) => {
      const hasWhitespace = /\s/.test(control.value);
      return hasWhitespace ? { whiteSpace: true } : null;
    };

    this.loginForm = this.fb.group({
      email: [
        '',
        Validators.compose([Validators.required, ValidateCustomEmail])
      ],
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          noWhiteSpaces
        ])
      ]
    });
  }

  submit(): void {
    if (this.loginForm.valid) {
      const loginRequest = new LoginRequest();
      loginRequest.password = this.loginForm.get('password').value as string;
      loginRequest.email = this.loginForm.get('email').value as string;
      this.authService.login(loginRequest).subscribe(
        (response) => {
          localStorage.setItem('vetId', response.vetId.toString());
          if (response.accessToken && !response.hasChangePassword) {
            this.authService
              .setLoginItems(response, this.redirect)
              .then((resp) => {
                if (resp) {
                  this.searchVet();
                }
              });
          }

          if (response.hasChangePassword) {
            this.authService
              .requestChangePassword(loginRequest.email)
              .subscribe((resp) => {
                if (resp) {
                  this.router.navigate([
                    'redefinir-senha/',
                    loginRequest.email
                  ]);
                }
              });
          }

          if (!response.hasCpf) {
            this.router.navigate([
              'atualizar-cpf'
            ]);
          }
        },
        (err) => {
          if (err?.status === 403) {
            const errorBody = err?.error as RegistrationErrorModel | undefined;
            if (errorBody?.errorCode === 'PROFILE_INCOMPLETE') {
              this.toastrService.warning('Seu cadastro não foi finalizado. Complete seu perfil para continuar.');
              this.router.navigate(['cadastro'], {
                queryParams: {
                  email: loginRequest.email,
                  completeRegister: true,
                  ignoreCpf: errorBody?.ignoreCpf ?? null
                }
              });
            } else {
              this.toastrService.warning('Seu e-mail ainda não foi verificado. Verifique sua caixa de entrada e confirme o código para continuar.');
              this.router.navigate(['cadastro'], {
                queryParams: { email: loginRequest.email }
              });
            }
          } else {
            this.incorrectData = true;
          }
        }
      );
    } else {
      this.loginForm.markAllAsTouched();
    }
  }

  searchVet(): void {
    this.authService.loadUserById().subscribe(
      (response) => {
        this.authService.setUser(response);
      },
      (error) => {
        if (error.message === 'User not found') {
          if (this.router.url.indexOf('/cadastro') !== 0) {
            void this.router.navigate(['cadastro']);
          }
        } else {
          void this.router.navigate(['perfil-nao-encontrado']);
        }
      }
    );
  }

  @HostListener('window:resize')
  getScreenSize(): void {
    this.screenWidth = window.innerWidth;
    this.mobileScreen = this.screenWidth <= 576;
  }
}
